import React from 'react';
import type { TplExecutiveJudgmentCard } from '../../../services/tplExecutiveJudgment';
import { TPL_SEVERITY_STYLE } from '../../../services/tplSeverityStyles';

interface TplExecutiveJudgmentCardsProps {
  cards: TplExecutiveJudgmentCard[];
  compact?: boolean;
  className?: string;
}

/**
 * Julgamento gerencial — Disciplina / Conformidade / Resultado em linguagem executiva.
 * Hierarquia: diagnóstico → exceção → severidade (nunca zeros vazios).
 */
export const TplExecutiveJudgmentCards: React.FC<TplExecutiveJudgmentCardsProps> = ({
  cards,
  compact = false,
  className = '',
}) => (
  <div
    className={`grid gap-2 ${compact ? 'grid-cols-1 sm:grid-cols-3' : 'grid-cols-1 sm:grid-cols-3'} ${className}`}
  >
    {cards.map((card) => {
      const style = TPL_SEVERITY_STYLE[card.severity];
      return (
        <div
          key={card.key}
          className={`rounded-lg border p-2.5 ${style.border} ${style.bg}`}
        >
          <p className="text-[9px] font-bold uppercase tracking-wide text-slate-500 dark:text-slate-400">
            {card.key === 'disciplina' ? 'Disciplina' : card.key === 'conformidade' ? 'Conformidade' : 'Resultado'}
          </p>
          <p className={`mt-0.5 text-[11px] font-semibold ${style.text}`}>{card.metricLabel}</p>
          <p className={`mt-1 font-black tabular-nums leading-none ${style.accent} ${compact ? 'text-[20px]' : 'text-[24px]'}`}>
            {card.value}
          </p>
          {card.detail && (
            <p className="mt-1 text-[10px] font-medium text-slate-700 dark:text-slate-300">{card.detail}</p>
          )}
          <span className={`mt-1.5 inline-flex rounded px-1.5 py-0.5 text-[8px] font-bold uppercase ${style.badge}`}>
            {card.severityLabel}
          </span>
        </div>
      );
    })}
  </div>
);

export default TplExecutiveJudgmentCards;
